import { useMemo } from 'react';

import { useMatches } from '@tanstack/react-router';

import type { IStaticBlocksData } from '@dcentralexpedientedigital/fe-shared/types/config.interface';

import { isBlocks } from '../utils/is-blocks';

export function useBlocks() {
    const matches = useMatches();

    return useMemo(
        () =>
            matches.find(({ staticData }) => isBlocks(staticData))?.staticData as IStaticBlocksData,
        [matches],
    );
}
